<template>
  <base-wrapper>
    <div class="space-y-4">
      <div class="flex items-center justify-end gap-x-2">
        <base-input
          :shadow="false"
          placeholder="Cari Kode atau Nama"
          type="text"
          debounce
          label="Cari"
          v-on:native-input="onFilter"
          v-model="filter.search"
        />
      </div>
      <datatable
        :columns="columns"
        :scroll-x="false"
        :total="offices.meta.page.total"
        :perPage="offices.meta.page.perPage"
        :currentPage="offices.meta.page.currentPage"
        :meta="offices.meta"
        cursor
        @pagechanged="onPageChanged"
      >
        <template v-slot:tbody="{ classes }">
          <tr
            v-for="office in offices.data"
            :key="office.id"
            :class="[classes.tr, 'bg-white hover:bg-green-100']"
          >
            <td :class="[classes.td]">
              <span class="font-bold text-gray-900">
                {{ office.attributes.code }} /
                {{ office.attributes.temp_code }}
              </span>
            </td>
            <td :class="[classes.td]">
              {{ office.attributes.name || '-' }}
            </td>
            <td :class="[classes.td]">
              {{ getOffice(office).attributes.pvpri | toCurrency }}
            </td>
            <td :class="[classes.td]">
              {{ getOffice(office).attributes.bvpri | toCurrency }}
            </td>
            <td :class="[classes.td]">
              {{ getOffice(office).attributes.pvgroup | toCurrency }}
            </td>
            <td :class="[classes.td]">
              {{ getOffice(office).attributes.pvgroup | toCurrency }}
            </td>
          </tr>
        </template>
      </datatable>
    </div>

    <loading v-if="loading" />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';

export default {
  mixins: [requestMixin],
  components: {
  },
  data() {
    return {
      loading: false,
      offices: {
        data: [],
        meta: {
          page: {},
        },
      },
      filter: {
        search: null,
      },
    };
  },
  computed: {
    columns() {
      return [
        { id: 'code', name: 'Nomor Mitra Usaha' },
        { id: 'name', name: 'Nama Mitra Usaha' },
        { id: 'pvpri', name: 'PVPRI' },
        { id: 'bvpri', name: 'BVPRI' },
        { id: 'pvgroup', name: 'PVGROUP' },
        { id: 'bvgroup', name: 'BVGROUP' },
      ];
    },
  },
  methods: {
    onPageChanged(page) {
      this.loadOffices({
        ...page,
      });
    },
    onFilter() {
      this.loadOffices();
    },
    getOffice(office) {
      return this.getSingleIncludedType('office', this.offices, office);
    },
    async loadOffices(params) {
      this.loading = true;

      const [res, error] = await this.request('/api/v1/offices', {
        params: {
          'page[limit]': 5,
          'filter[search]': this.filter.search,
          'filter[period_uuid]': this.filter.periodId,
          'fields[simple-offices]': 'code,temp_code,name,office_id,office',
          'fields[offices]': 'name,pvpri,bvpri,pvgroup,bvgroup',
          'filter[office_category_id]': 5,
          include: 'office',
          ...params,
        },
      });

      if (!error) {
        this.offices = res;
      }

      this.loading = false;
    },
  },
  created() {
    this.loadOffices();
  },
};
</script>
